import { PageSource, cartViewLocation } from 'shared/constants/dataLayer';

export const getCartViewLocation = (pageType: string) => {
  switch (pageType) {
    case PageSource.ALL_SHADE:
      return cartViewLocation.ALL_SHADE;
    case PageSource.SIZE_CHART:
      return cartViewLocation.SIZE_CHART_VIEW_BAG;
    default:
      return cartViewLocation.PRODUCT_PAGE;
  }
};
